import React from 'react';
import NavigationButton from 'components/atoms/NavigationButton';
import * as S from './ImageViewer.styles';

interface ImageViewerProps {
  src: string;
  alt: string;
  currentIndex: number;
  totalImages: number;
  onPrevious: () => void;
  onNext: () => void;
  canGoBack: boolean;
  canGoForward: boolean;
}

export default function ImageViewer({
  src,
  alt,
  currentIndex,
  totalImages,
  onPrevious,
  onNext,
  canGoBack,
  canGoForward,
}: ImageViewerProps) {
  return (
    <S.Container>
      {canGoBack && (
        <NavigationButton direction="left" onClick={onPrevious} />
      )}
      
      <S.Image src={src} alt={alt} />
      
      {canGoForward && (
        <NavigationButton direction="right" onClick={onNext} />
      )}
      
      <S.Counter>
        {currentIndex + 1} de {totalImages}
      </S.Counter>
    </S.Container>
  );
}